export function createSummaryMethods(api) {
    return {
        async getSummary(campaignId) {
            const {data} = await api.gamemasterCampaignsSummaryRetrieve(campaignId);
            return data;
        },

        /** Never raises — the report itself carries `is_publishable` and the reasons. */
        async validate(campaignId) {
            const {data} = await api.gamemasterCampaignsValidateRetrieve(campaignId);
            return data;
        },
    };
}
